import { useState } from "react";

const WhatsAppSettings = () => {
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Input handler - sanitize and force "+"
  const handleNumberChange = (e) => {
    let value = e.target.value;

    if (value.charAt(0) !== "+") {
      value = `+${value.replace(/[^\d]/g, "")}`;
    } else {
      value = `+${value.slice(1).replace(/[^\d]/g, "")}`;
    }

    setWhatsappNumber(value);
  };

  // Save button handler
  const saveNumber = async () => {
    setMessage("");

    if (!whatsappNumber.trim()) {
      setMessage("❌ Please enter a valid WhatsApp number.");
      return;
    }

    // Fix here: use 'authToken' key to get the token
    const token = localStorage.getItem("authToken");
    if (!token) {
      setMessage("❌ You are not authenticated. Please login.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        "https://backend.aktcorp.com/whatsapp/update-number",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ number: whatsappNumber }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setMessage("✅ WhatsApp number updated successfully!");
        setWhatsappNumber("");
      } else {
        setMessage(`❌ ${data.error || data.message || "Error updating number."}`);
      }
    } catch (err) {
      setMessage("❌ Network error while updating number.");
    } finally {
      setLoading(false);
      setTimeout(() => setMessage(""), 5000);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-900">
      <div className="p-8 mt-10 w-full max-w-lg bg-white shadow-2xl rounded-3xl text-center border border-gray-300">
        <h2 className="text-3xl font-bold text-gray-900">Update WhatsApp Number</h2>

        <input
          type="text"
          value={whatsappNumber}
          onChange={handleNumberChange}
          placeholder="Enter WhatsApp Number"
          className="mt-6 border border-gray-500 p-3 w-full rounded-lg bg-white text-gray-900"
          disabled={loading}
        />

        {!loading ? (
          <button
            onClick={saveNumber}
            className="w-full mt-6 bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700"
          >
            Update
          </button>
        ) : (
          <div className="w-8 h-8 border-4 border-t-transparent border-blue-600 rounded-full mx-auto mt-6 animate-spin"></div>
        )}

        {message && (
          <p
            className={`text-sm mt-4 font-medium ${
              message.startsWith("✅") ? "text-green-500" : "text-red-500"
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default WhatsAppSettings;
